import {store} from "_helpers/store";

export function sortObj(list, key) {
  function compare(a, b) {
    a = a[key]
    b = b[key]
    let type = (typeof (a) === 'string' ||
      typeof (b) === 'string') ? 'string' : 'number'
    let result
    if (type === 'string') result = a.localeCompare(b)
    else result = a - b
    return result
  }

  return list.sort(compare)
}


export function get_sorted_devices(allowed_device_types = null) {
  const {all_commissioned_devices} = store.getState().device_fleet
  let devices = all_commissioned_devices
  if (allowed_device_types) {
    devices = devices.filter(device => allowed_device_types.includes(device["device_type"]))
  }
  return devices.sort((a, b) => {
    return a["name"] < b["name"] ? -1 : 1
  })
}